import { WHATSAPP_API } from '../config/config';

// Servicio multi-sesión de WhatsApp.
// Endpoints backend esperados:
// POST   /sessions                 -> crear nueva sesión { sessionId, ... }
// GET    /sessions                 -> listar sesiones [{ id, status, number, ... }]
// GET    /sessions/:id/status      -> estado detallado de una sesión
// GET    /sessions/:id/qr          -> obtener o renovar QR { qr }
// POST   /sessions/:id/send        -> enviar mensaje { ok }
// POST   /sessions/:id/reset       -> reset para pedir nuevo QR
// DELETE /sessions/:id             -> elimina sesión
// (Opcional futuro: PATCH /sessions/:id para metadata)

// Cache de QR por sessionId para reducir parpadeo y requests.
// Cada entrada: { value, fetchedAt }
const qrCache = new Map();
const DEFAULT_QR_TTL_MS = 15000; // ajustable según expiración real del backend

const buildUrl = (id, suffix) => `/sessions/${id}${suffix ? `/${suffix}` : ''}`;

const listSessions = async () => {
  const resp = await WHATSAPP_API.get('/sessions');
  return resp.data;
};

const createSession = async () => {
  const resp = await WHATSAPP_API.post('/sessions');
  return resp.data; // se espera { sessionId, ... }
};

const deleteSession = async (id) => {
  const resp = await WHATSAPP_API.delete(buildUrl(id, ''));
  // Limpiar cache relacionado
  qrCache.delete(id);
  return resp.data;
};

const getStatus = async (id) => {
  const resp = await WHATSAPP_API.get(buildUrl(id, 'status'));
  return resp.data;
};

const getQR = async (id, { fresh = false } = {}) => {
  const url = fresh ? `${buildUrl(id, 'qr')}?fresh=true` : buildUrl(id, 'qr');
  const resp = await WHATSAPP_API.get(url);
  return resp.data;
};

const getCachedQR = async (id, { force = false, fresh = false, ttlMs = DEFAULT_QR_TTL_MS } = {}) => {
  const entry = qrCache.get(id) || { value: null, fetchedAt: 0 };
  const now = Date.now();
  const age = now - entry.fetchedAt;
  const valid = entry.value && age < ttlMs;
  if (!force && !fresh && valid) {
    return { qr: entry.value, cached: true, ageMs: age };
  }
  const data = await getQR(id, { fresh });
  if (data?.qr) {
    qrCache.set(id, { value: data.qr, fetchedAt: Date.now() });
  }
  return { ...data, cached: false, ageMs: 0 };
};

const clearQRCache = (id) => {
  if (id) qrCache.delete(id);
};

const resetSession = async (id) => {
  const resp = await WHATSAPP_API.post(buildUrl(id, 'reset'));
  clearQRCache(id);
  return resp.data;
};

// Enviar mensaje (texto y opcionalmente imágenes) a un grupo.
// Nuevo contrato backend: { group, message, imageUrls?: string[] }
// imageUrls debe ser un array de URLs absolutas ya accesibles para el backend.
const sendMessage = async (id, group, message, imageUrls) => {
  const payload = { group, message };
  if (Array.isArray(imageUrls) && imageUrls.length > 0) {
    // Filtrar valores vacíos y asegurar strings
    payload.imageUrls = imageUrls.filter(u => typeof u === 'string' && u.trim().length > 0);
  }
  //payload.rapid = true;
//payload.captionMode = 'last';
  const resp = await WHATSAPP_API.post(buildUrl(id, 'send'), payload);
  return resp.data;
};

const WhatsappSessionsService = {
  listSessions,
  createSession,
  deleteSession,
  getStatus,
  getQR,
  getCachedQR,
  clearQRCache,
  resetSession,
  sendMessage
};

export default WhatsappSessionsService;
